let tooltipId = 0;

class CompPriceTooltip extends HTMLElement {
  #controller;
  #trigger;
  #tooltip;
  #pinned = false;
  #hideTimer;

  connectedCallback() {
    this.#trigger = this.querySelector('.comp-price__trigger');
    this.#tooltip = this.querySelector('.comp-price__tooltip');
    if (!this.#trigger || !this.#tooltip) return;

    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#tooltip.id = `CompPriceTooltip-${++tooltipId}`;
    this.#trigger.setAttribute('aria-describedby', this.#tooltip.id);
    this.#trigger.setAttribute('aria-controls', this.#tooltip.id);
    this.#hide();

    for (const element of [this.#trigger, this.#tooltip]) {
      element.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.#show();
      }, { signal });
      element.addEventListener('pointerleave', () => {
        if (!this.#pinned && !this.#trigger.matches(':focus-visible')) {
          this.#hideTimer = setTimeout(() => this.#hide(), 100);
        }
      }, { signal });
    }
    this.#trigger.addEventListener('focus', () => this.#show(), { signal });
    this.#trigger.addEventListener('click', () => {
      if (this.#pinned) {
        this.#hide();
      } else {
        this.#pinned = true;
        this.#show();
      }
    }, { signal });
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget) && !this.#trigger.matches(':hover') && !this.#tooltip.matches(':hover')) {
        this.#hide();
      }
    }, { signal });
    document.addEventListener('pointerdown', (event) => {
      if (!this.#trigger.contains(event.target) && !this.#tooltip.contains(event.target)) this.#hide();
    }, { signal, capture: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.#tooltip.hidden) {
        event.stopPropagation();
        this.#hide();
      }
    }, { signal, capture: true });
    window.addEventListener('resize', this.#position, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    clearTimeout(this.#hideTimer);
  }

  #show() {
    clearTimeout(this.#hideTimer);
    this.#tooltip.hidden = false;
    this.#trigger.setAttribute('aria-expanded', 'true');
    this.#position();
  }

  #hide() {
    clearTimeout(this.#hideTimer);
    this.#pinned = false;
    this.#tooltip.hidden = true;
    this.#trigger.setAttribute('aria-expanded', 'false');
  }

  #position = () => {
    if (this.#tooltip.hidden) return;
    this.style.setProperty('--comp-price-offset', '0px');
    const bounds = this.#tooltip.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const offset = Math.max(16 - bounds.left, Math.min(0, viewportWidth - 16 - bounds.right));
    this.style.setProperty('--comp-price-offset', `${offset}px`);
  };
}

if (!customElements.get('comp-price-tooltip')) {
  customElements.define('comp-price-tooltip', CompPriceTooltip);
}
